import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'related',
  templateUrl: './related.component.html',
  styleUrls: ['./related.component.sass']
})
export class RelatedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
